export const texts = [
  [
    {
      text: 'Curves in motion',
      count: 400,
      fontSize: 100,
    },
    {
      text: 'Twisting and bending',
      count: 800,
      fontSize: 100,
    },
    {
      text: "Reacting to your presence",
      count: 1200,
      fontSize: 50,
    },
    {
      text: 'Flowing like water',
      count: 1600,
      fontSize: 250,
    },
    {
      text: "Unpredictable yet smooth",
      count: 2000,
      fontSize: 100,
    },
    {
      text: 'Endless possibilities',
      count: 2400,
      fontSize: 200,
    },
    {
      text: '',
      count: 3000,
      fontSize: 400,
    },
  ],
  [
    {
      text: 'Motion through time',
      count: 400,
      fontSize: 100,
    },
    {
      text: 'Shapes reshaping',
      count: 800,
      fontSize: 100,
    },
    {
      text: "Transforming reality",
      count: 1200,
      fontSize: 100,
    },
    {
      text: 'Endless motion',
      count: 1600,
      fontSize: 100,
    },
    {
      text: "Continuous change",
      count: 2000,
      fontSize: 100,
    },
    {
      text: 'Ever evolving',
      count: 2400,
      fontSize: 100,
    },
    {
      text: '',
      count: 3000,
      fontSize: 400,
    },
  ],
  [
    {
      text: 'Dynamic and alive',
      count: 400,
      fontSize: 200,
    },
    {
      text: 'Energy in motion',
      count: 800,
      fontSize: 125,
    },
    {
      text: 'Vibrating with life',
      count: 1200,
      fontSize: 100,
    },
    {
      text: 'Unstoppable force',
      count: 1600,
      fontSize: 200,
    },
    {
      text: 'Tremors of creation',
      count: 2000,
      fontSize: 100,
    },
    {
      text: '',
      count: 3000,
      fontSize: 10,
    },
  ],
];

export default texts;
